module.exports = __webpack_public_path__ + "img/mp3.a6890966.png";